export default function fuel({ color }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="22"
      height="24"
      fill={color}
      viewBox="0 0 22 24"
    >
      <path
        fill={color}
        d="M17.75 1.107a.856.856 0 00-1.214 0L14.57 3.071l-1.816-1.816A4.248 4.248 0 009.725 0h-5.44A4.292 4.292 0 000 4.286v17.143A2.574 2.574 0 002.571 24H18a2.574 2.574 0 002.571-2.571v-12a.87.87 0 00-.25-.608l-1.107-1.107L21.18 5.75a.856.856 0 000-1.214L17.75 1.107zm1.107 20.322a.856.856 0 01-.857.857H2.571a.856.856 0 01-.857-.857V4.286a2.574 2.574 0 012.572-2.572h5.438a2.53 2.53 0 011.817.755l7.316 7.317v11.643zM18 6.505l-2.214-2.214 1.357-1.357 2.214 2.214L18 6.505z"
      ></path>
      <path
        fill={color}
        d="M4.285 9.429a.869.869 0 00-.857.857v9.428c0 .434.372.858.857.858h12c.47 0 .857-.419.857-.858v-9.428c0-.434-.398-.857-.857-.857h-12zm11.143 8.52L11.673 15l3.755-2.949v5.898zM5.142 12.051l3.755 2.95-3.755 2.948v-5.898zm5.143 4.041l3.52 2.765h-7.04l3.52-2.765zm0-2.184l-3.52-2.765h7.04l-3.52 2.765zM3.428 5.143v-.857c0-.475.382-.857.857-.857h5.143c.474 0 .857.382.857.857v.857A.856.856 0 019.428 6H4.285a.856.856 0 01-.857-.857z"
      ></path>
    </svg>
  );
}
